"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.document_question_mark = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var document_question_mark = function document_question_mark(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'document-question-mark-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M2.25 2C2.25 1.58579 2.58579 1.25 3 1.25H14C14.1989 1.25 14.3897 1.32902 14.5303 1.46967L17.5303 4.46967C17.671 4.61032 17.75 4.80109 17.75 5V18C17.75 18.4142 17.4142 18.75 17 18.75H3C2.58579 18.75 2.25 18.4142 2.25 18V2ZM3.75 2.75V17.25H16.25V5.31066L13.6893 2.75H3.75Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M7 8.44922H8.58789C8.62305 7.78711 9.06836 7.35938 9.74219 7.35938C10.4102 7.35938 10.8555 7.76367 10.8555 8.32031C10.8555 8.87695 10.627 9.16406 9.87109 9.61523C9.0625 10.0898 8.74023 10.6172 8.81641 11.5371L8.82812 11.877H10.3809V11.5664C10.3809 10.9922 10.5977 10.7051 11.377 10.2539C12.2031 9.76758 12.6309 9.15234 12.6309 8.26758C12.6309 6.93164 11.5234 6 9.84766 6C8.04883 6 7.0293 7.00781 7 8.44922ZM9.66602 14.7012C10.3223 14.7012 10.7266 14.3262 10.7266 13.7227C10.7266 13.1133 10.3223 12.7383 9.66602 12.7383C9.00977 12.7383 8.59961 13.1133 8.59961 13.7227C8.59961 14.3262 9.00977 14.7012 9.66602 14.7012Z',
    fill: '#4B5563'
  }));
};

exports.document_question_mark = document_question_mark;